import type { Product } from '@/libs/interfaces'

import {
  MOCK_PRODUCT_CATEGORY_ID_ACCESSORIES,
  MOCK_PRODUCT_CATEGORY_ID_BRAKE_PARTS,
  MOCK_PRODUCT_CATEGORY_ID_FILTERS,
  MOCK_PRODUCT_CATEGORY_ID_FLUIDS,
  MOCK_PRODUCT_CATEGORY_ID_TIRES,
} from './categories'
import { MOCK_ORG_ID, MOCK_STORE_ID_1, MOCK_STORE_ID_2 } from './seed'

const isoTimestamp = '2025-01-12T08:00:00Z'

export const mockProducts: Product[] = [
  {
    productID: 'product-1',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    currency: 'SEK',
    productInventoryBalance: 40,
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
    productItemNumber: 'PRD-001',
    cost: 120,
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_FLUIDS,
    productDescription: 'Synthetic Engine Oil 5W-30 (5L)',
    award: 350,
    type: 'Local',
  },
  {
    productID: 'product-2',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    currency: 'SEK',
    productInventoryBalance: 60,
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
    productItemNumber: 'PRD-002',
    cost: 25,
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_FILTERS,
    productDescription: 'Oil Filter',
    award: 80,
    type: 'Local',
  },
  {
    productID: 'product-3',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    currency: 'SEK',
    productInventoryBalance: 35,
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
    productItemNumber: 'PRD-003',
    cost: 30,
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_FILTERS,
    productDescription: 'Cabin Air Filter',
    award: 90,
    type: 'Local',
  },
  {
    productID: 'product-4',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    currency: 'SEK',
    productInventoryBalance: 20,
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
    productItemNumber: 'PRD-004',
    cost: 220,
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_BRAKE_PARTS,
    productDescription: 'Front Brake Pads Set',
    award: 600,
    type: 'Local',
  },
  {
    productID: 'product-5',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    currency: 'SEK',
    productInventoryBalance: 15,
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
    productItemNumber: 'PRD-005',
    cost: 350,
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_BRAKE_PARTS,
    productDescription: 'Brake Discs (Pair)',
    award: 900,
    type: 'Local',
  },
  {
    productID: 'product-6',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_2,
    currency: 'SEK',
    productInventoryBalance: 8,
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
    productItemNumber: 'PRD-006',
    cost: 950,
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_TIRES,
    productDescription: 'All-Season Tire 205/55R16',
    award: 1800,
    type: 'Local',
  },
  {
    productID: 'product-7',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    currency: 'SEK',
    productInventoryBalance: 50,
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
    productItemNumber: 'PRD-007',
    cost: 18,
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_FLUIDS,
    productDescription: 'Windshield Washer Fluid (1L)',
    award: 45,
    type: 'Local',
  },
  {
    productID: 'product-8',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    currency: 'SEK',
    productInventoryBalance: 25,
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
    productItemNumber: 'PRD-008',
    cost: 65,
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_ACCESSORIES,
    productDescription: 'Wiper Blade Set',
    award: 150,
    type: 'Local',
  },
]
